import React from 'react';
import PlayIcon from './assets/icons/play2.svg';
import styles from './ProgramsVideoPlayer/ProgramsVideoPlayer.scss';
export const VideoCover = _ref => {
  let {
    poster,
    onPlayClick,
    className = '',
    dataHook = 'video-cover',
    isMobile = false
  } = _ref;
  const baseClassName = `${styles.base}${isMobile ? ` ${styles.baseMobile}` : ''}${className ? ` ${className}` : ''}`;
  return /*#__PURE__*/React.createElement("div", {
    className: baseClassName,
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cover,
    "data-hook": `${dataHook}_cover`
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.coverImage,
    alt: "video cover",
    src: poster
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.play,
    "data-hook": `${dataHook}_btn`,
    onClick: onPlayClick,
    "aria-label": "Play video"
  }, /*#__PURE__*/React.createElement(PlayIcon, null))));
};
//# sourceMappingURL=VideoCover.js.map